module.exports = __webpack_public_path__ + "static/turn-the-ship-around-d1912802168cada6b106af2c502b044c.jpg";